import React, { MouseEventHandler } from 'react';
import { create } from 'zustand';

interface ZoneMenuItem {
  title: string;
  subTitle?: string;
  icon: React.ReactNode;
  disabled: boolean;
  isActive: boolean;
  isVisible: boolean;
  path?: string;
  onClick?: MouseEventHandler<any>;
}

interface SatV5ZoneMenuItem extends ZoneMenuItem {}
interface ContentZoneMenuItem extends ZoneMenuItem {}
interface WorkflowZoneMenuItem extends ZoneMenuItem {}
interface CommunicationZoneMenuItem extends ZoneMenuItem {}
interface ManagementInformationZoneMenuItem extends ZoneMenuItem {}
interface SchoolZoneMenuItem extends ZoneMenuItem {
  popupItems?: {
    title: string;
    path: string;
    icon: React.ReactNode;
  }[];
}
interface TimeTableZoneMenuItem extends ZoneMenuItem {}
interface ChallengeZoneMenuItem extends ZoneMenuItem {}
interface ContactZoneMenuItem extends ZoneMenuItem {}
interface CommsZoneMenuItem extends ZoneMenuItem {}
interface SatModuleZoneMenuItem extends ZoneMenuItem {}

interface ZoneMenuState {
  schoolZone?: SchoolZoneMenuItem;
  satV5Zone?: SatV5ZoneMenuItem;
  contentZone?: ContentZoneMenuItem;
  communicationZone?: CommunicationZoneMenuItem;
  managementInformationZone?: ManagementInformationZoneMenuItem;
  workflowZone?: WorkflowZoneMenuItem;
  timeTableZone?: TimeTableZoneMenuItem;
  challengeZone?: ChallengeZoneMenuItem;
  contactZone?: ContactZoneMenuItem;
  commsZone?: CommsZoneMenuItem;
  satModuleZone?: SatModuleZoneMenuItem;
}

interface ZoneMenuHandlers {
  setSchoolZone: (schoolZone: Partial<SchoolZoneMenuItem>) => void;
  setSatV5Zone: (satV5Zone: Partial<SatV5ZoneMenuItem>) => void;
  setContentZone: (contentZone: Partial<ContentZoneMenuItem>) => void;
  setCommunicationZone: (communicationZone: Partial<CommunicationZoneMenuItem>) => void;
  setManagementInformationZone: (managementInformationZone: Partial<ManagementInformationZoneMenuItem>) => void;
  setWorkflowZone: (workflowZone: Partial<WorkflowZoneMenuItem>) => void;
  setTimeTableZone: (timeTableZone: Partial<TimeTableZoneMenuItem>) => void;
  setContactZone: (contactZone: Partial<ContactZoneMenuItem>) => void;
  setCommsZone: (commsZone: Partial<CommsZoneMenuItem>) => void;
  setZoneMenu: (zoneMenu: Partial<ZoneMenuState>) => void;
  setChallengeZone: (challengeZone: Partial<ChallengeZoneMenuItem>) => void;
  setSatModuleZone: (satModuleZone: Partial<SatModuleZoneMenuItem>) => void;
}

export interface ZoneStore extends ZoneMenuHandlers, ZoneMenuState {}

export const useZoneStore = create<ZoneStore>()((set) => ({
  setSchoolZone: (schoolZone) => set((prev) => ({ ...prev, schoolZone: { ...prev.schoolZone, ...schoolZone } })),
  setContentZone: (contentZone) => set((prev) => ({ ...prev, contentZone: { ...prev.contentZone, ...contentZone } })),
  setCommunicationZone: (communicationZone) =>
    set((prev) => ({ ...prev, communicationZone: { ...prev.communicationZone, ...communicationZone } })),
  setManagementInformationZone: (managementInformationZone) =>
    set((prev) => ({
      ...prev,
      managementInformationZone: { ...prev.managementInformationZone, ...managementInformationZone },
    })),
  setWorkflowZone: (workflowZone) =>
    set((prev) => ({ ...prev, workflowZone: { ...prev.workflowZone, ...workflowZone } })),
  setTimeTableZone: (timeTableZone) =>
    set((prev) => ({ ...prev, timeTableZone: { ...prev.timeTableZone, ...timeTableZone } })),
  setChallengeZone: (challengeZone) =>
    set((prev) => ({ ...prev, challengeZone: { ...prev.challengeZone, ...challengeZone } })),
  setContactZone: (contactZone) => set((prev) => ({ ...prev, contactZone: { ...prev.contactZone, ...contactZone } })),
  setCommsZone: (commsZone) => set((prev) => ({ ...prev, commsZone: { ...prev.commsZone, ...commsZone } })),
  setZoneMenu: (zoneMenu) => set((prev) => ({ ...prev, ...zoneMenu })),
  setSatV5Zone: (satV5Zone) => set((prev) => ({ ...prev, satV5Zone: { ...prev.satV5Zone, ...satV5Zone } })),
  setSatModuleZone: (satModuleZone) =>
    set((prev) => ({ ...prev, satModuleZone: { ...prev.satModuleZone, ...satModuleZone } })),
}));
